import { Component, Input, OnInit } from '@angular/core';
import { AuthloginService } from 'src/app/services/login/authlogin.service';
import { SubmitdataService } from 'src/app/services/submitdata/submitdata.service';
import Highcharts from 'highcharts';
import { ConstantsModule } from 'src/app/common/constants/constants.module';
import {monthmaps,dataSubs} from 'src/assets/i18n/hi.json';

@Component({
  selector: 'app-state-dgcreports',
  templateUrl: './state-dgcreports.component.html',
  styleUrls: ['./state-dgcreports.component.css']
})
export class StateDgcreportsComponent implements OnInit {
  yearDropDownList: any;
  dgcGraphFilter: object = {'ay':"",'lu':"","month":""};
  userdetails: any;
  state: any;
  initData: any;
  @Input() selectedlanguage:string;
  enableNgOnChanges: boolean;

  constructor(
    private submitdataSerivce : SubmitdataService,
    private logsrv : AuthloginService,
    private constants : ConstantsModule  ) { }

  ngOnInit() {
    this.submitdataSerivce.getStatusOfToken();
    this.userdetails = this.logsrv.checkloginstatus();
    this.getdynamicYears();
    this.getstateslist();
    this.getGraphData();
  }

  ngOnChanges(){
    if(this.enableNgOnChanges){
      this.formatDataForCharts();
    }
  }

  getdynamicYears(){
    let date = new Date();
    let currentYear = date.getFullYear();
    let currentmonth = date.getMonth();
    let dropDownYear;
    if(currentmonth <3){
      dropDownYear = (currentYear - 1) + '-'+ currentYear;
    } else{
      dropDownYear = currentYear + '-'+ (currentYear + 1);
    }
    this.submitdataSerivce.getYearsToDisplay(this.submitdataSerivce.yearsPayload).subscribe(data=>{
      this.yearDropDownList = data['data'];
    });
    this.dgcGraphFilter['ay'] = dropDownYear;  
  }

  getstateslist(){
    // this.activeSpinner = true;
    let postdata = {};
    postdata['pType'] = this.constants.LOCATION_CONSTANT['BASIN'];
    postdata['cType'] = this.constants.LOCATION_CONSTANT['STATE'];
    postdata["component"] = "";
    postdata["src"] = "";
    this.submitdataSerivce.getLocationList(postdata).subscribe(data => {
      if (data) {
        this.state = null;
        Object.keys(data).forEach(key => {
          data[key].forEach(statelist => {
            if (statelist['uuid'] == this.userdetails['loggedUserData']['userProfile']['stateUUID']) {
              this.state = statelist;
              // console.log("statee",this.state);              
              // this.state.sort((a, b) => (a.name > b.name) ? 1 : -1);
            }

          });
        })
      }
    });
  }

  getGraphData(){
    let postdata = {};
    postdata['ay'] = this.dgcGraphFilter['ay'];
    postdata['lu'] = this.dgcGraphFilter['lu'];
    postdata['subTp'] = ["04","05","06","07","08","09","10","11","12","01","02","03"];
    postdata['lu'] = this.userdetails['loggedUserData']['userProfile']['stateUUID'];
        
    this.submitdataSerivce.dataforReportChart(postdata).subscribe(data =>{
      // console.log("data",data['data']);
      this.initData = data['data'];
      this.formatDataForCharts();
      this.enableNgOnChanges = true;
    })    
  }

  formatDataForCharts(){
    let data = this.initData;
    let subData = [];
    let nonSubData = [];
    let lineChartData = [];
    // console.log("data",data);  
    
    Object.keys(data).forEach(mon =>{
      // console.log("mon",mon,data[mon]);
      Object.values(data[mon]).forEach(state=>{
        let subValue = parseInt(state['submitted count'][0]);
        let nonSubValue = parseInt(state['pending count'][0]);
        let item1 = {
          'name' : this.selectedlanguage == 'en'? this.getMonthName(this.formatMonth(mon)) : monthmaps[this.getMonthName(this.formatMonth(mon))],
          'y' : subValue,
          // 'DGCsList' : state['submitted'],
          // 'type' : 'submitted'
        };
        let item2 = {
          'name' : this.selectedlanguage == 'en'? this.getMonthName(this.formatMonth(mon)) : monthmaps[this.getMonthName(this.formatMonth(mon))],
          'y' : nonSubValue,
          // 'DGCsList' : state['pending'],
          // 'type' : 'not submitted'
        };
        // subData.push([state, subValue,]);
        // nonSubData.push([state, nonSubValue,]);
        subData.push(item1);
        nonSubData.push(item2);
        if(subValue != 0)
          lineChartData.push(item1);
      })      
    })

    this.createDoubleColmnChart(subData, nonSubData);
    this.createLineChart(lineChartData);
  }

  createDoubleColmnChart(subData,nonSubData){   
    // console.log("DC chart",subData,nonSubData);
    let chartTitleEn = "MoM status for Assessment year " + this.dgcGraphFilter['ay'];
    let chartTitleHi = "आकलन वर्ष के लिए एमओएम स्थिति " + this.dgcGraphFilter['ay'];
    // let xaxisEn = ;
    // let xaxisHi = ;
    Highcharts.chart('double-column-chart', {
      chart:{
        type: 'column'
      },
      title: {
        text: this.selectedlanguage == 'en'? chartTitleEn : chartTitleHi
      },
      xAxis:{
        type: 'category',
        title: {
          text: this.selectedlanguage == 'en'? 'Months':dataSubs.months,
          style: {
            fontSize: '20px',
            color: 'black'
          }          
        },
        labels: {
          style: {
            color: 'black',
            fontSize: '15px'
          }
        }
      },
      yAxis: {
        title: {
          text: this.selectedlanguage == 'en'? 'No. of DGCs' : 'डीजीसी की संख्या',
          style: {
            fontSize: '18px',
            color: 'black'
          }
        },
        labels: {
          style: {
          color: 'black',
          fontSize: '14px'
          }
        }
      },
      tooltip: {
        headerFormat: `<div>{point.key}</div><br>`,
        pointFormat: `<div>{series.name}: <b>{point.y}</b></div>`,
      },
      credits: {
        enabled: false
      },
      legend: {
        enabled: false
      },
      plotOptions:{
        column: {
          point: {
            events: {
              click: (e) =>{
                // console.log("selected",e.point.options);
                // this.openDGCsListWindow(e.point.options);
              }
            }
          }
        }
      },
      series: [{
        name: this.selectedlanguage == 'en'? 'Submitted' : 'प्रस्तुत',
        data: subData,
        color: 'green',
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '13px',            
            fontFamily: 'Verdana, sans-serif'
          }
        }
      },
    {
      name: this.selectedlanguage == 'en'? 'Not submitted' : 'प्रस्तुत नही किया है',
      data: nonSubData,
      color: 'red',
      dataLabels: {
        enabled: true,
        style: {
          fontSize: '13px',            
          fontFamily: 'Verdana, sans-serif'
        }
      }
    }]
    } as any);
  }

  createLineChart(data){
    // console.log("line data",data);
    let chartTitleEn = "Month wise status for Assessment year "+ this.dgcGraphFilter['ay'];
    let chartTitleHi = "निर्धारण वर्ष के लिए माह वार स्थिति " + this.dgcGraphFilter['ay'];
    Highcharts.chart('line-chart', {
      chart:{
        type: 'line'
      },
      title: {
        text: this.selectedlanguage == 'en'? chartTitleEn : chartTitleHi
      },
      xAxis:{
        //  categories: ['April','May','June','July','August','September','October','November','December','January','February','March'],
        type: 'category',
        title: {
          text: this.selectedlanguage == 'en'? 'Months':dataSubs.months,
          style: {
            fontSize: '20px',
            color: 'black'
          }          
        },
        labels: {
          style: {
            color: 'black',
            fontSize: '15px'
          }
        },
        min: 0,
        max: 11
      },
      yAxis: {
        title: {
          text: this.selectedlanguage == 'en'? 'No. of DGCs submitted' : 'जमा किए गए डीजीसी की संख्या',
          style: {
            fontSize: '18px',
            color: 'black'
          }
        },
        labels: {
          style: {
          color: 'black',
          fontSize: '14px'
         }
        }
      },
      tooltip: {
        enabled : true,
        headerFormat: `<div>{point.key}</div><br>`,
        pointFormat: `<div>{series.name}: <b>{point.y}</b></div>`,
        split : true
      },
      credits: {
        enabled: false
      },
      legend: {
        enabled: false
      },
      // plotOptions:{
      // },
      series: [{
        name: this.selectedlanguage == 'en'? 'Submitted' : 'प्रस्तुत',
        data: data,
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '13px',            
            fontFamily: 'Verdana, sans-serif'
          }
        }
      }]
    } as any);
  }

  formatMonth(key){
    let monthKey = key.substring(1,3);
    return monthKey;
  }

  getMonthName(num){
    let date = new Date();
    date.setMonth(num - 1);
    return date.toLocaleString('en-US', { month: 'long' });
  }

  titleCase(str){    
    str = str.toLowerCase().split(' ');
    for(var i = 0; i < str.length; i++){
      str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
    }
    return str.join(' ');
  }

}
